import React from "react";
import ColorField from "./ColorField";

// Long enough for "Acme Support Assistant", short enough that the widget
// header still fits the name beside the avatar and the online badge.
const NAME_MAX = 30;

export default function BrandAppearanceCard({ settings, onChange }) {
  return (
    <section className="dash-card cz-card">
      <h2 className="cz-card-title">1. Brand appearance</h2>

      {/* The name the widget introduces itself by, set when the assistant was
          created and changeable ever since - it just had nowhere to be
          changed from. It heads this card because it is the first thing a
          visitor reads in the widget. */}
      <label className="cz-field cz-name-field">
        <span className="cz-field-label">Assistant name</span>
        <input
          type="text"
          className="cz-text-input"
          maxLength={NAME_MAX}
          placeholder="e.g. Acme Support"
          value={settings.name || ""}
          onChange={(e) => onChange("name", e.target.value)}
        />
        <span className="cz-field-hint">
          Shown in the widget header on your website.
        </span>
      </label>

      <div className="cz-color-grid">
        <ColorField
          label="Primary color"
          value={settings.primaryColor}
          onChange={(v) => onChange("primaryColor", v)}
        />
        <ColorField label="Header color" value={settings.headerColor} onChange={(v) => onChange("headerColor", v)} />
        <ColorField label="Accent color" value={settings.accentColor} onChange={(v) => onChange("accentColor", v)} />
        <ColorField label="Button color" value={settings.buttonColor} onChange={(v) => onChange("buttonColor", v)} />
      </div>
    </section>
  );
}
